// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://njoxbqtqffsfhkwgbksu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5qb3hicXRxZmZzZmhrd2dia3N1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcwODIwMzgsImV4cCI6MjA2MjY1ODAzOH0.9oc7WqijAADtde6p3x9Z7pVwSQDFdrtJ345_hT8rXr8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

/**
 * Set JWT token for authenticated requests
 */
export const setSupabaseJWT = (token: string) => {
  // For native Supabase auth, we don't need to manually set JWT tokens
  // This function is kept for compatibility but doesn't need to do anything
  console.log('JWT token handling is managed by Supabase auth');
};

/**
 * Check if Supabase is properly configured
 */
export const isSupabaseConfigured = (): boolean => {
  return !!(SUPABASE_URL && SUPABASE_PUBLISHABLE_KEY);
};